module.exports = __webpack_public_path__ + "img/shareGreen.487fcc26.svg";